define('pages/home',["exports", "backbone"], function (_exports, _backbone) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = _backbone.View.extend({
    events: {},
    currency() {
      location.reload();
    }
  });
});//# sourceMappingURL=home.js.map
;
